import { lazy, Suspense } from "react"

const Landing = lazy(() => import("./landing"))

export function LandingPage() {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center">
          <div className="border-primary h-10 w-10 animate-spin rounded-full border-b-2" />
        </div>
      }
    >
      <Landing />
    </Suspense>
  )
}
